module.exports = __webpack_public_path__ + "static/media/google_icon.686f8efa.svg";